import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api.js'
import { useAuth } from '../contexts/AuthContext.jsx'
import { addDays, formatDate, relativeDay } from '../lib/dates.js'

// Most of the user base, on phones, outdoors, in gloves. Big text, no hover, no chrome.

export default function MySchedule() {
  const { mode, modeName } = useAuth()
  const today = mode?.today
  const from = today
  const to = today ? addDays(today, 14) : null

  const { data, isLoading } = useQuery({
    queryKey: ['my-schedule', from, to],
    queryFn: () => api.get(`/api/my-schedule?from=${from}&to=${to}`),
    enabled: Boolean(from && to),
    refetchInterval: 60_000,
  })

  if (isLoading || !data) return <div className="page empty">Loading your schedule…</div>

  const days = data.days.filter((d) => d.entries.length > 0 || d.date === today)

  return (
    <div className="page">
      <div className="my-schedule">
        <div className="page-head">
          <h1>My schedule</h1>
        </div>

        {days.length === 0 && (
          <div className="card empty">Nothing scheduled for you in the next two weeks.</div>
        )}

        {days.map((day) => {
          const rel = relativeDay(day.date, today)
          return (
            <div key={day.date} className={`day-card ${day.date === today ? 'today' : ''}`}>
              <div className="day-head">
                <span className="big">{formatDate(day.date)}</span>
                {rel && <span className="rel">{rel}</span>}
                <span style={{ marginLeft: 'auto' }}>
                  {/* A day in a different mode than today is labelled, so nobody is
                      surprised on Monday morning. */}
                  {day.mode === 'cat' && (
                    <span className="tag cat">{modeName('cat')}{day.modeLabel ? ` · ${day.modeLabel}` : ''}</span>
                  )}
                </span>
              </div>

              {day.entries.length === 0 ? (
                <div className="nothing">Nothing scheduled.</div>
              ) : (
                day.entries.map((e) => (
                  <div className="job" key={e.id}>
                    <div className="job-label">{e.label}</div>
                    <div className="job-meta">
                      {e.jobTypeName && <span className="chip">{e.jobTypeName}</span>}
                      {/* In normal mode the group IS the PM, so naming them twice reads as a
                          bug. Show the team only when it is a different thing from the
                          person you would call about it. */}
                      {e.groupName && e.groupName !== e.contactName && (
                        <span>
                          {e.groupColor && (
                            <span className="group-swatch" style={{ background: e.groupColor }} />
                          )}
                          {e.groupName}
                        </span>
                      )}
                      {e.contactName &&
                        (e.contactPhone ? (
                          <a href={`tel:${e.contactPhone}`}>{e.contactName}</a>
                        ) : (
                          <span>{e.contactName}</span>
                        ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
